import React, { useState, useRef } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { navigationItems } from '../data/mock';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsResourcesOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsResourcesOpen(false);
    }, 150);
  };

  return (
    <nav className="bg-white/95 backdrop-blur-md border-b border-blue-200 sticky z-40" style={{ top: '40px' }}>
      <div className="container">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center flex-shrink-0">
            <a href="/" className="text-lg font-semibold bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent whitespace-nowrap">
              Zero To Cloud
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block flex-1">
            <div className="ml-6 flex items-baseline space-x-6">
              {navigationItems.map((item) => {
                if (item.name === 'Free Resources') {
                  return (
                    <div 
                      key={item.name} 
                      className="relative"
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <button
                        className="px-2 py-2 text-sm font-medium transition-colors duration-200 text-gray-700 hover:text-blue-600 flex items-center gap-1 whitespace-nowrap"
                      >
                        {item.name}
                        <ChevronDown size={16} className={`transition-transform ${isResourcesOpen ? 'rotate-180' : ''}`} />
                      </button>
                      
                      {isResourcesOpen && (
                        <div 
                          className="absolute top-full left-0 w-64 bg-white rounded-md shadow-lg border border-blue-200 py-2 z-[9999]"
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                        >
                          <a
                            href="/cloud-role-quiz"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                          >
                            Cloud Career Quiz
                          </a>
                          <a
                            href="/free/cloud-engineer-roadmap"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                          >
                            📄 90-Day Cloud Engineer Checklist
                          </a>
                          <a
                            href="/free/solutions-architect-roadmap"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                          >
                            📄 90-Day Solutions Architect Checklist
                          </a>
                          <a
                            href="/course/free-project-aws-cloud-fun-facts-generator"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                          >
                            Free Cloud Project
                          </a>
                          <a
                            href="https://www.cloudbites.ai/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                          >
                            Cloudbites Newsletter
                          </a>
                        </div>
                      )}
                    </div>
                  );
                }
                
                return (
                  <a
                    key={item.name}
                    href={item.href}
                    className="px-2 py-2 text-sm font-medium transition-colors duration-200 whitespace-nowrap text-gray-700 hover:text-blue-600"
                  >
                    {item.name}
                  </a>
                );
              })}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-200">
              {navigationItems.map((item) => {
                if (item.isDropdown) {
                  return (
                    <div key={item.name} className="px-3 py-2">
                      <div className="text-base font-medium text-gray-700 mb-2">{item.name}</div>
                      <div className="ml-4 space-y-1">
                        <a
                          href="/cloud-role-quiz"
                          className="block px-2 py-1 text-sm text-gray-600 hover:text-blue-600"
                        >
                          Cloud Career Quiz
                        </a>
                        <a
                          href="/free/cloud-engineer-roadmap"
                          className="block px-2 py-1 text-sm text-gray-600 hover:text-blue-600"
                        >
                          📄 90-Day Cloud Engineer Checklist
                        </a>
                        <a
                          href="/free/solutions-architect-roadmap"
                          className="block px-2 py-1 text-sm text-gray-600 hover:text-blue-600"
                        >
                          📄 90-Day Solutions Architect Checklist
                        </a>
                        <a
                          href="/course/free-project-aws-cloud-fun-facts-generator"
                          className="block px-2 py-1 text-sm text-gray-600 hover:text-blue-600"
                        >
                          Free Cloud Project
                        </a>
                        <a
                          href="https://www.cloudbites.ai/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block px-2 py-1 text-sm text-gray-600 hover:text-blue-600"
                        >
                          Cloudbites Newsletter
                        </a>
                      </div>
                    </div>
                  );
                }
                
                return (
                  <a
                    key={item.name}
                    href={item.href}
                    className="block px-3 py-2 text-base font-medium transition-colors text-gray-700 hover:text-blue-600"
                  >
                    {item.name}
                  </a>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;